import React from 'react';
import { prop, pick } from 'ramda';
import { Link } from 'js/components/common/Link';
import { usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import { useAppSelector } from 'js/store/hooks';
import style from './index.scss';

export const Empty = () => {
    const t = usePortletTranslations();
    const depositPage = useAppSelector(prop('depositPage'));

    const {
        haveNotDeposited,
        lastMethodDoesntSupportQd,
        description
    } = usePortletSelector(pick([
        'haveNotDeposited',
        'lastMethodDoesntSupportQd',
        'description'
    ]));

    let dscTk = 'empty.description';

    if (haveNotDeposited) {
        dscTk += '.haveNotDeposited';
    } else if (lastMethodDoesntSupportQd) {
        dscTk += '.noActiveQuickDeposit';
    }

    return (
        <div className={`${style.empty}`}>
            <div className={style.image} />
            <div className={style.title}>{t('empty.title')}</div>
            <div
                className={style.description}
                dangerouslySetInnerHTML={{ __html: description || t(dscTk) }}
            />
            {!description && (
                <div className={style.link}>
                    <Link href={depositPage}>{t('empty.link.depositPage')}</Link>
                </div>
            )}
        </div>
    );
};

export default Empty;
